import { useDark, useToggle } from '@vueuse/core'

const isDark = useDark({ selector: 'html' })
const toggleDark = useToggle(isDark)

export function useDarkMode() {
  return {
    isDark,
    toggleDark,
  }
}
